import { TOAST_TYPE } from '@/constants/toasts'
import EventBus from '@/EventBus'

/**
 * This shows toast messages
 * @param message
 * @param type - typeof TOAST_TYPE
 */
export default (message, type = TOAST_TYPE.SUCCESS, dismissAfter) => {
  EventBus.$emit('ADD_TOAST', {
    message,
    type,
    dismissAfter
  })
}
